/* @flow */
// typecheck: ignore file
import { Container } from 'flux/utils';
import React from 'react';
import Dialog from 'components/Dialog.jsx';
import Activity from 'entities/Activity';
import ActivityFormEditHandler from 'payments/components/ActivityFormEditHandler.jsx';
import ToastAction from 'actions/ToastActions';
import BoxBody from 'components/BoxBody.jsx';
import CurrentUser from 'auth/CurrentUser';

import './styles/ActivityEditModal.scss';

type Props = {
  activity: Activity,
  onRequestHide?: () => any,
};

type State = {
  canCollectMoney: boolean,
};

class ActivityEditModal extends React.Component {
  props: Props;
  state: State;

  static getStores() {
    return [
      CurrentUser,
    ];
  }

  static calculateState(): State {
    return {
      canCollectMoney: CurrentUser.getUser().canCollectMoney(),
    };
  }

  onEdited = () => {
    ToastAction.showSuccessToast('Changes saved');
    if (this.props.onRequestHide) {
      this.props.onRequestHide();
    }
  }

  render() {
    const { activity, onRequestHide, ...rest } = this.props;

    return (
      <Dialog
        eventScreenName="ActivityEditModal"
        {...rest}
        className="ActivityEditModal"
        onRequestHide={onRequestHide}>
        <BoxBody>
          <ActivityFormEditHandler
            canCollectMoney={this.state.canCollectMoney}
            initialActivity={activity}
            onEdited={this.onEdited}
          />
        </BoxBody>
      </Dialog>
    );
  }
}

export default Container.create(ActivityEditModal, { withProps: true });



// WEBPACK FOOTER //
// ./src/payments/components/ActivityEditModal.jsx